import React from 'react';
import {
  Button,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { PageTitle } from '@cordata/buffet';

import { UncontrolledTable } from '~/components/common';

import { useAdmin } from '~/utils/admin';

const defaultSorted = [{
  id: 'lastname',
}, {
  id: 'firstname',
}];

const columns = [{
  id: 'lastname',
  Header: 'Last Name',
  accessor: 'attributes.lastname',
}, {
  id: 'firstname',
  Header: 'First Name',
  accessor: 'attributes.firstname',
}, {
  id: 'displayName',
  Header: 'Display Name',
  accessor: 'attributes.displayName',
}, {
  id: 'providerRoleLabel',
  Header: 'Role / Specialty',
  accessor: 'attributes.providerRoleLabel',
}, {
  id: 'npiNumber',
  Header: 'NPI Number',
  accessor: 'attributes.npiNumber',
}];

const IndexProviders = () => {
  const history = useHistory();
  const { org } = useAdmin();

  return (<>
    <PageTitle
      action={
        <Button
          outline
          tag={Link}
          to="/admin/providers/add"
        >
          <FontAwesomeIcon icon="plus" />
          <span className="d-none d-md-inline ml-2">Add Provider</span>
        </Button>
      }
    >
      Providers
    </PageTitle>

    {org &&
      <UncontrolledTable
        name="providers"
        defaultSorted={defaultSorted}
        endpoint={{
          url: 'admin/provider',
          params: {
            'org-uid': org.id,
          },
        }}
        columns={columns}
        getTrProps={(state, rowInfo) => ({
          style: {
            cursor: 'pointer',
          },
          onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/admin/providers/${rowInfo.original.id}`)),
        })}
      />
    }
  </>);
};

export default IndexProviders;
